/**
 * Dopina `panel=true` do ścieżki/URL (jak callbackUrl po logowaniu), żeby po rejestracji
 * nawigacja otworzyła modal panelu usera. Checkout pomijamy — tam user ma wrócić do zamówienia.
 * Tylko client-side (signup redirect / handleRegister).
 */
export const ensurePanelTrueSearchParam = (pathOrUrl: string): string => {
  if (!pathOrUrl || pathOrUrl.includes('/checkout')) {
    return pathOrUrl;
  }

  try {
    const url = new URL(pathOrUrl, window.location.origin);
    url.searchParams.set('panel', 'true');

    if (url.origin === window.location.origin) {
      return `${url.pathname}${url.search}${url.hash}`;
    }

    return url.toString();
  } catch {
    return pathOrUrl;
  }
};

/**
 * Usuwa prefiks locale ze ścieżki pod `router.push`.
 * Next sam dokłada aktualne locale — push `/fr?panel=true` przy locale=fr kończy się jako `/fr/fr`.
 */
export const stripLocalePrefixForRouterPush = (pathOrUrl: string, locale?: string, defaultLocale?: string): string => {
  if (!pathOrUrl) return pathOrUrl;

  try {
    const url = new URL(pathOrUrl, window.location.origin);
    let { pathname } = url;

    if (locale && defaultLocale && locale !== defaultLocale) {
      const prefix = `/${locale}`;
      if (pathname === prefix || pathname === `${prefix}/`) {
        pathname = '/';
      } else if (pathname.startsWith(`${prefix}/`)) {
        pathname = pathname.slice(prefix.length) || '/';
      }
    }

    if (url.origin === window.location.origin) {
      return `${pathname}${url.search}${url.hash}`;
    }

    return url.toString();
  } catch {
    return pathOrUrl;
  }
};

/** Ścieżka po rejestracji bez prefiksu locale (pod Next router.push). Otwarcie panelu — sessionStorage. */
export const buildPostRegistrationRedirectPath = (pathOrUrl: string, locale?: string, defaultLocale?: string): string =>
  stripLocalePrefixForRouterPush(pathOrUrl, locale, defaultLocale);
